import Filter from './filter';

export default Filter((FILTER_TYPES) => ({
  id: 'ADULTHOTEL',
  analyticsName: 'Adults recommended',
  queryKey: 'f_adult',
  type: FILTER_TYPES.BOOLEAN,
  bucketify: (hotel) => {
    const isAdultHotel = hotel?.isAdultHotel;

    if (isAdultHotel) {
      return {
        bucketId: FILTER_TYPES.BINARY_BUCKET.TRUE,
        bucketName: 'allAdultsHotel',
      };
    }

    return {
      bucketId: FILTER_TYPES.BINARY_BUCKET.FALSE,
      bucketName: 'allAdultsHotel',
    };
  },
  toQuery: ({ value }) => {
    return value ? 1 : undefined;
  },
  fromQuery: (rawQueryValue) => {
    return {
      [FILTER_TYPES.BINARY_BUCKET.TRUE]: !!rawQueryValue,
    };
  },
}));
